meedy.factory('meedy.integrationsService', ['$q', '$translate', '$http', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig', '$sce',
    function ($q, $translate, $http, baseService, objectHelper, config, $sce) {

        function InvoiceService() {

            this.getAlabExaminationResultFileLink = function (term, file) {
                return baseService.get(config.API_URL + '/terms/' + term.id + '/examinationResults/' + file.id).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        $q.reject(errorResponse);
                    }
                );
            };

            this.downloadExaminationFileAndOpenNewTab = function (url) {
                var options = {
                    headers: {
                        'Content-type': 'application/pdf'
                    },
                    responseType: 'arraybuffer'
                };

                return baseService.get(url, options).then(
                    function(successResponse) {
                        var file = new Blob([successResponse], { type: 'application/pdf' });
                        var fileURL = URL.createObjectURL(file);
                        return window.open(fileURL);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getP1EReferralPreview = function (body) {
                return baseService.post(config.API_URL + '/integrations/edm/p1/referral/html', body).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        $q.reject(errorResponse);
                    }
                );
            };

        }

        return new InvoiceService();
    }
]);
